import angular from 'angular'
import './ambassador_giveaway.service'

angular
  .module('admin.ambassador_giveaway', ['admin.ambassador_giveaway.service'])
  .controller('AmbassadorGiveawayAdminCtrl', AmbassadorGiveawayAdminCtrl)

/** @ngInject */
function AmbassadorGiveawayAdminCtrl($state, $rootScope, AmbassadorGiveawayService) {
  var vm = this
  vm.items = []
  vm.itemsLogs = []
  vm.perPage = 25
  vm.prints = []
  vm.printsSelected = false
  vm.collectibleByChannelId = null
  vm.collectibleBySetId = null
  vm.collectibleByCollectibleId = null
  vm.username = ''
  vm.pId = ''
  vm.pNumber = ''
  vm.userFrom = ''
  vm.userTo = ''

  function reloadPaginationEscrow() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationLog() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  reloadPaginationEscrow()
  reloadPaginationLog()

  var tab = localStorage.getItem('ambassador_giveaway')
  if (tab !== null) {
    if (tab === 'escrow') {
      $('#log').removeClass('active')
      $('#escrow').addClass('active')
      $('#escrowtab').addClass('active')
    } else {
      $('#escrow').removeClass('active')
      $('#log').addClass('active')
      $('#logtab').addClass('active')
    }
  } else {
    $('#escrow').addClass('active')
    $('#escrowtab').addClass('active')
  }

  vm.tabEscrows = function() {
    $('#log').removeClass('active')
    $('#escrow').addClass('active')
    localStorage.setItem('ambassador_giveaway', 'escrow')
  }

  vm.tabLogs = function() {
    $('#escrow').removeClass('active')
    $('#log').addClass('active')
    localStorage.setItem('ambassador_giveaway', 'logs')
  }

  function loadEscrow(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    AmbassadorGiveawayService.list(vm.oldPage, 25, vm.username, vm.pId, vm.pNumber).then(function(
      result,
    ) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
      }
      vm.items = result.results
    })
  }

  function loadLogs(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    AmbassadorGiveawayService.listTransfer(vm.oldPage, 25, vm.userFrom, vm.userTo).then(function(
      result,
    ) {
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i].k === 1) {
          result.results[i].type = 'Bundle Purchase'
        } else if (result.results[i].k === 2) {
          result.results[i].type = 'Trade'
        } else if (result.results[i].k === 3) {
          result.results[i].type = 'Listing'
        } else if (result.results[i].k === 4) {
          result.results[i].type = 'Ebay Auction'
        } else if (result.results[i].k === 5) {
          result.results[i].type = 'Account Transfer'
        } else if (result.results[i].k === 6) {
          result.results[i].type = 'Print Transfer'
        } else if (result.results[i].k === 7) {
          result.results[i].type = 'Giveaway'
        } else if (result.results[i].k === 8) {
          result.results[i].type = 'Mintable Wallet Association'
        } else {
          result.results[i].type = 'Unknownn'
        }

        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
      }

      vm.itemsLogs = result.results
    })
  }

  loadEscrow(1)
  loadLogs(1)

  vm.load = function() {
    reloadPaginationEscrow()
    loadEscrow(1)
  }

  vm.loadLog = function() {
    reloadPaginationLog()
    loadLogs(1)
  }

  vm.pageChanged = function(newPage) {
    loadEscrow(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function(newPage) {
    loadLogs(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.deleteEscrow = function(id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          AmbassadorGiveawayService.remove(id).then(
            function() {
              loadEscrow(1)
            },
            function(err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }
}
